/**
 * Desc:
 * Created Date: Tuesday, September 10th 2024, 6:39:46 pm
 * Author: jim Li
 * -----
 * Last Modified: Tue May 13 2025
 * Modified By: jim Li
 */

export default {
  Tag_Common: {
    Shi: 'Yes',
    Fou: 'No',
    QiYon: 'Enabled',
    TingYon: 'Disabled',
    Fu: 'Combo',
    Dan: 'Single',
    Nong: 'Ratio',
    DaiRu: 'Bring',
    Tian: 'Day',
    XiaoShi: 'H',
    FenZhong: 'M',
    FenZhong_10: '10 mins',
    FenZhong_15: '15 mins',
    FenZhong_20: '20 mins',
    FenZhong_30: '30 mins',
    FenZhong_60: '1 hr',
    XuanZe: 'Select',
    Yi: 'Mon.',
    Er: 'Tue.',
    San: 'Wed.',
    Si: 'Thu.',
    Wu: 'Fri.',
    Liu: 'Sat.',
    Ri: 'Sun.',
    You: 'Has',
    Wu_Y: 'None',
    Zhou_Yi: 'Mon.',
    Zhou_Er: 'Tue.',
    Zhou_San: 'Wed.',
    Zhou_Si: 'Thu.',
    Zhou_Wu: 'Fri.',
    Zhou_Liu: 'Sat.',
    Zhou_Ri: 'Sun.',
  },
}
